(() => {
  if (customElements.get("size-selector")) return;

  class SizeSelector extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tabs.forEach((btn) => {
        btn.addEventListener("click", () => this.activate(btn.dataset.tab));
      });
      const initial = this.dataset.defaultTab || (this.panels[0] && this.panels[0].dataset.panel) || "standard";
      this.activate(initial);
      this._bindForm();
      this._bindSelectWraps();
    }

    activate(name) {
      this.tabs.forEach((b) => b.setAttribute("aria-selected", b.dataset.tab === name ? "true" : "false"));
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panel === name;
        panel.hidden = !isActive;
        panel.querySelectorAll("input, select, textarea").forEach((field) => {
          field.disabled = !isActive;
        });
      });
      if (this._form) this._syncMirrors();
    }

    _bindForm() {
      const namedField = this.querySelector("[form]");
      const wantedId = namedField ? namedField.getAttribute("form") : null;
      let form = wantedId ? document.getElementById(wantedId) : null;
      if (!form) form = document.querySelector('form[is="product-form"]');
      if (!form) return;
      this._form = form;
      this._createMirrors();
      this.addEventListener("change", () => this._syncMirrors());
      this.addEventListener("input", () => this._syncMirrors());

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.addEventListener("click", (e) => this._validateRequired(e), true);
      }

      const buyNowBtn = document.getElementById("gokwik-buy-now");
      if (buyNowBtn) {
        buyNowBtn.addEventListener("click", (e) => this._validateRequired(e), true);
      }
    }

    _validateRequired(e) {
      const invalidField = Array.from(
        this.querySelectorAll("input:not([disabled]), select:not([disabled]), textarea:not([disabled])")
      ).find((field) => field.required && !field.value.trim());

      if (invalidField) {
        e.preventDefault();
        e.stopImmediatePropagation();
        invalidField.focus();
        invalidField.setCustomValidity("Please fill in this field.");
        invalidField.reportValidity();
        invalidField.addEventListener("input", () => invalidField.setCustomValidity(""), { once: true });
      }
    }

    _createMirrors() {
      this._form.querySelectorAll('input[data-size-mirror]').forEach((m) => m.remove());
      this.querySelectorAll("input, select, textarea").forEach((field) => {
        if (!field.name) return;
        // Store original name so we can restore it when value is entered
        field.dataset.originalName = field.name;
        const hasValue = !field.disabled && field.value.trim();
        // Remove name from empty/disabled source fields so GoKwik can't pick them up
        if (!hasValue) field.removeAttribute("name");
        const mirror = document.createElement("input");
        mirror.type = "hidden";
        mirror.dataset.sizeMirror = field.dataset.originalName;
        if (hasValue) {
          mirror.name = field.dataset.originalName;
          mirror.value = field.value;
        } else {
          mirror.disabled = true;
        }
        this._form.appendChild(mirror);
      });
    }

    _bindSelectWraps() {
      this.querySelectorAll('.size-selector-select-wrap').forEach((wrap) => {
        wrap.addEventListener('click', (e) => {
          if (e.target.closest('select')) return;
          const select = wrap.querySelector('select');
          if (select) select.showPicker();
        });
      });
    }

    _syncMirrors() {
      this.querySelectorAll("input, select, textarea").forEach((field) => {
        const origName = field.dataset.originalName || field.name;
        if (!origName) return;
        const mirror = this._form.querySelector(`input[data-size-mirror="${CSS.escape(origName)}"]`);
        if (!mirror) return;
        if (field.disabled || !field.value.trim()) {
          field.removeAttribute("name");
          mirror.removeAttribute("name");
          mirror.value = "";
          mirror.disabled = true;
        } else {
          field.name = origName;
          mirror.name = origName;
          mirror.value = field.value;
          mirror.disabled = false;
        }
      });
    }
  }

  customElements.define("size-selector", SizeSelector);
})();
